var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionSortDate1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7h16v11a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7Z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 2h2v2h6V2h2v2h1a2 2 0 0 1 2 2v1H2V6a2 2 0 0 1 2-2h1V2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.354 11.237 9.998 9H12v9h-2v-6.382l-1.354 1.146-1.292-1.527Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m24 15-4 5V5h2v10h2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionSortDate1);
export default __webpack_public_path__ + "static/media/ic_action_sort_date_1.64461f942ad1fa1d941716454f08acef.svg";
export { ForwardRef as ReactComponent };